import { createRoot } from 'react-dom/client';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import '@/components/DataGrid/license';
import { IS_DEV_MODE } from '@/constants';
import { ErrorBoundary } from '@/error-handling';
import SnackbarProvider from '@/sections/Snackbar/Provider';
import { AnalyticsProvider } from '@/utils/analytics/segment/AnalyticsContext';
import { ApolloProvider } from '@apollo/client';
import { PylonProvider } from '@bolasim/react-use-pylon';
import { DialogsProvider } from '@toolpad/core/useDialogs';
import { RecoilRoot } from 'recoil';
import { RecoilDevTools } from 'recoil-toolkit';

import App from './App';
import apolloClient from './apollo';
import ThemeProvider from './theme/ThemeProvider';
import { initializeSentry } from './utils/analytics/Sentry';

initializeSentry();

const container = document.getElementById('react-app') as HTMLElement;
const root = createRoot(container);

root.render(
  <AnalyticsProvider>
    <ApolloProvider client={apolloClient}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <RecoilRoot>
          {IS_DEV_MODE && <RecoilDevTools />}
          <ThemeProvider>
            <DialogsProvider>
              <SnackbarProvider>
                <PylonProvider
                  chatSettings={{
                    appId: ENV_CONFIG.PYLON_APP_ID,
                  }}
                  autoBoot
                  shouldInitialize={!!ENV_CONFIG.PYLON_APP_ID}
                >
                  <ErrorBoundary>
                    <App />
                  </ErrorBoundary>
                </PylonProvider>
              </SnackbarProvider>
            </DialogsProvider>
          </ThemeProvider>
        </RecoilRoot>
      </LocalizationProvider>
    </ApolloProvider>
  </AnalyticsProvider>,
);
